'use client';

import { Card } from '@/components/ui/card';

interface SettingsSectionProps {
  title: string;
  description?: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function SettingsSection({
  title,
  description,
  icon,
  children,
  className = '',
}: SettingsSectionProps) {
  return (
    <Card className={`bg-gray-900/50 border-gray-800 p-4 md:p-6 ${className}`}>
      <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-red-600/10 flex items-center justify-center flex-shrink-0">
          {icon}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg md:text-xl font-bold text-white mb-1">{title}</h3>
          {description && (
            <p className="text-xs md:text-sm text-gray-400">{description}</p>
          )}
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">{children}</div>
    </Card>
  );
}

interface SettingItemProps {
  label: string;
  description?: string;
  children: React.ReactNode;
}

export function SettingItem({ label, description, children }: SettingItemProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4 py-3 md:py-4 border-b border-gray-800 last:border-0">
      <div className="flex-1 min-w-0">
        <label className="text-sm md:text-base font-medium text-white block">{label}</label>
        {description && (
          <p className="text-xs md:text-sm text-gray-500 mt-1">{description}</p>
        )}
      </div>
      <div className="flex-shrink-0 w-full sm:w-auto">{children}</div>
    </div>
  );
}
